const MMS_BLISTER = {
  countType: "blister",
  barcodeType: "MMS Blister",
  productName: "MMS Blister",
  detectionRoute: "/mms-blister-detection",
  actionLabel: "Start MMS Tablet Detection",
};

const MMS_BOTTLE = {
  countType: "bottle",
  barcodeType: "MMS Bottle",
  productName: "MMS Bottle",
  detectionRoute: "/camera",
  actionLabel: "Start Count Pills",
};

// ponytail: no Calcium counting flow yet (backend submit rejects calcium), so no detectionRoute; add one when it exists.
const CALCIUM = {
  countType: "calcium",
  barcodeType: "Calcium",
  productName: "Calcium",
  detectionRoute: null,
  actionLabel: null,
};

// Longest prefixes first: other M codes fall back to MMS Blister.
const BARCODE_PREFIXES = [
  { prefix: "M82", ...MMS_BLISTER },
  { prefix: "M81", ...MMS_BOTTLE },
  { prefix: "M", ...MMS_BLISTER },
  { prefix: "C", ...CALCIUM },
];

// Returns null for empty or unrecognized (non-MMS, non-Calcium) barcodes.
export function resolveBarcodeRoute(barcode) {
  if (!barcode || typeof barcode !== "string") {
    return null;
  }

  const trimmed = barcode.trim();
  const match = BARCODE_PREFIXES.find(({ prefix }) => trimmed.startsWith(prefix));
  if (!match) {
    return null;
  }

  const { prefix, ...routeInfo } = match;
  return routeInfo;
}
